import { api } from "@/lib/api";
import { Agency, AgencyDtoSchema, agencyFromDto, agencyToDto } from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getAgenciesQueryOptions, getAgencyQueryOptions } from "./get.hooks";

export function useUpdateAgency(opts?: {
  hideSuccessToast?: boolean;
  onSuccess?: (agency: Agency) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (agency: Agency) => {
      const dto = agencyToDto(agency);
      const result = await api.put("/api/agencies", dto, AgencyDtoSchema);
      return agencyFromDto(result);
    },
    onSuccess: (agency) => {
      queryClient.setQueryData(getAgenciesQueryOptions.queryKey, (old) =>
        old?.map((a) => (a.id === agency.id ? agency : a)),
      );
      queryClient.setQueryData(
        getAgencyQueryOptions(agency.id).queryKey,
        () => agency,
      );
      if (!opts?.hideSuccessToast)
        toast({
          title: "toast.agencyUpdated",
          variant: "success",
        });
      opts?.onSuccess?.(agency);
    },
    onError: () => {
      toast({
        title: "toast.updateAgencyError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
